// extracted by mini-css-extract-plugin
export default {"arrow":"Footer_arrow__h8S3E","footer":"Footer_footer__Mv40S","footerContent":"Footer_footerContent__zAUH1"};